var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isWizardActive)?_c('ViewportWrapper',[_c('UX1Steps',{attrs:{"currentStep":_vm.currentStep}},[_c('UX1Step',{attrs:{"title":_vm.viewTitle}}),_vm._l((_vm.wizardSteps),function(item,idx){return _c('UX1Step',{key:idx,attrs:{"title":_vm.stepTitles[item.id]}})})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }